// Stockage du consentement : cookie `vp_cookie_consent` (JSON URL-encodé), 180 jours
// (aligné sur la politique de rétention `cookies` — services/retention.py).
// La version du texte présentée est figée dans le cookie pour audit.

export const COOKIE_NAME = "vp_cookie_consent";
export const COOKIE_MAX_AGE_DAYS = 180;
export const CMP_VERSION = "1.0";

export const DEFAULT_STATE = {
  necessary: true,
  functional: false,
  analytics: false,
  marketing: false,
};

export const ALL_ACCEPTED = { necessary: true, functional: true, analytics: true, marketing: true };
export const ALL_REFUSED = { necessary: true, functional: false, analytics: false, marketing: false };

export const CATEGORIES = [
  { key: "necessary", label: "Strictement nécessaires", req: true,
    desc: "Authentification, session, sécurité anti-bruteforce. Ne peut être désactivé — indispensable au fonctionnement du site." },
  { key: "functional", label: "Fonctionnels",
    desc: "Mémorisation de vos préférences d'interface (thème sombre/clair) pour une expérience personnalisée." },
  { key: "analytics", label: "Mesure d'audience",
    desc: "Statistiques anonymisées de fréquentation pour améliorer le service. Aucun traceur tiers activé à ce jour." },
  { key: "marketing", label: "Publicité / retargeting",
    desc: "Non utilisé actuellement. Ce champ sera activé uniquement si une campagne publicitaire est déployée." },
];

export function writeCookie(state) {
  const value = encodeURIComponent(JSON.stringify({
    ...state,
    necessary: true,
    version: CMP_VERSION,
    updated_at: new Date().toISOString(),
  }));
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 3600;
  document.cookie = `${COOKIE_NAME}=${value}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}

export function readCookie() {
  const match = document.cookie
    .split(";").map((c) => c.trim())
    .find((c) => c.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match.split("=", 2)[1]));
  } catch { return null; }
}
